import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../services/api";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PrintIcon from "@mui/icons-material/Print";
import logo from "../../assets/logo.png";

function VoucherPrint() {
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const res = await API.get(`/Voucher/get/${id}`);
            setData(res.data);
        } catch (err) {
            console.error("Error loading voucher:", err);
        }
    };

    const printPage = () => {
        window.print();
    };

    const numberToWords = (num) => {
        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six",
            "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
            "Thirteen", "Fourteen", "Fifteen", "Sixteen",
            "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

        const inWords = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
            if (n < 1000) return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
            if (n < 100000) return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
            if (n < 10000000) return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);
            return inWords(Math.floor(n / 10000000)) + " Crore " + inWords(n % 10000000);
        };

        return inWords(Math.floor(num)) + " Rupees Only";
    };

    const navigate = useNavigate();

    if (!data) return <div>Loading...</div>;

    return (
        <div style={styles.container}>

            {/* ✅ PRINT CSS */}
            <style>
                {`
                @media print {
                    img {
                            max-height: 50px;
                        }
                    @page {
                        margin: 5mm;
                    }

                    body {
                        margin: 0;
                    }

                    body * {
                        visibility: hidden;
                    }

                    #voucher-print, #voucher-print * {
                        visibility: visible;
                    }

                    #voucher-print {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        padding: 10px;
                        box-sizing: border-box;
                    }

                    button {
                        display: none !important;
                    }
                }
                `}
            </style>

            <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>

                <Button
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate("/app/voucher-entry")}
                    sx={styles.actionBtn}
                >
                    Back
                </Button>

                <Button
                    variant="contained"
                    startIcon={<PrintIcon />}
                    onClick={printPage}
                    sx={styles.actionBtn}
                >
                    Print
                </Button>

            </div>

            {/* ✅ IMPORTANT ID */}
            <div id="voucher-print" style={styles.voucherBox}>
                {/* ✅ WATERMARK */}
                <div style={styles.watermark}>
                    <img src={logo} alt="watermark" style={styles.watermarkImg} />
                </div>

                {/* HEADER */}
                <div style={styles.headerGrid}>
                    <div style={styles.logoBox}>
                        <img src={logo} alt="logo" style={styles.logo} />
                    </div>

                    <div style={styles.title}>
                        CRM ENTERPRISES PVT. LTD.
                        <div style={styles.address}>
                            HO : Flat No 1001 1st Floor Jubilee ballpark,
                            Road No 2, Jubilee Hills, Near Krishnanagar,
                            Hyderabad - 500 045 (T.S.), India
                        </div>
                    </div>

                    <div></div> {/* empty right space for balance */}
                </div>

                {/* TOP ROW */}
                <div style={styles.topRow}>
                    <div>V.No: {data.voucherNo}</div>
                    <div>
                        Date: {data.voucherDate
                            ? new Date(data.voucherDate).toLocaleDateString("en-IN")
                            : ""}
                    </div>
                </div>

                {/* DETAILS */}
                <div style={styles.infoRowFlex}>
                    <div>
                        <b>Place:</b> {data.place || "-"}
                    </div>

                    <div style={styles.voucherTitle}>
                        VOUCHER
                    </div>

                    <div>
                        <b>Paid To:</b> {data.paidTo || "-"}
                    </div>
                </div>

                {/* TABLE */}
                <table style={styles.table}>
                    <colgroup>
                        <col style={{ width: "70%" }} />
                        <col style={{ width: "30%" }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th style={styles.th}>Description</th>
                            <th style={styles.th}>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(data.details || []).map((d, i) => (
                            <tr key={i}>
                                <td style={styles.td}>{d.description}</td>
                                <td style={{ ...styles.td, textAlign: "right" }}>
                                    ₹ {Number(d.amount || 0).toFixed(2)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* TOTAL */}
                <div style={styles.total}>
                    Total: ₹ {Number(data.totalAmount || 0).toFixed(2)}
                </div>

                {/* WORDS */}
                <div style={styles.words}>
                    <b>Amount in Words:</b> {numberToWords(data.totalAmount)}
                </div>

                {/* FOOTER */}
                <div style={styles.footer}>
                    <div>
                        <div style={styles.signLine}></div>
                        Approved By
                    </div>

                    <div>
                        <div style={styles.signLine}></div>
                        Cashier
                    </div>

                    <div>
                        <div style={styles.signLine}></div>
                        Received By
                    </div>
                </div>

            </div>
        </div>
    );
}

const styles = {
    container: {
        padding: "20px",
        fontFamily: "Verdana",
        fontSize: "12px",
        background: "#fff"
    },
    printBtn: {
        marginBottom: "10px",
        padding: "5px 10px",
        cursor: "pointer"
    },
    voucherBox: {
        border: "2px solid #000",
        padding: "10px"
    },
    header: {
        textAlign: "center",
        marginBottom: "10px"
    },
    topRow: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px"
    },
    infoRow: {
        marginBottom: "5px"
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px"
    },
    th: {
        border: "1.5px solid #000",
        padding: "6px",
        fontWeight: "bold"
    },

    td: {
        border: "1px solid #000",
        padding: "5px",
        textAlign: "left"   // ✅ ADD THIS
    },
    total: {
        textAlign: "right",
        marginTop: "10px",
        fontWeight: "bold"
    },
    words: {
        marginTop: "10px",
        textAlign: "left"   // ✅ ADD
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "50px"
    },
    actionBtn: {
        background: "#1976d2",
        textTransform: "none",
        fontSize: "12px",
        padding: "4px 12px",
        minWidth: "70px",
        borderRadius: "6px",
        boxShadow: "none",
        "&:hover": {
            background: "#1565c0",
            boxShadow: "none"
        }
    },
    headerRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "10px"
    },
    headerWrapper: {
        position: "relative",
        marginBottom: "10px",
    },
    logo: {
        height: "50px"   // adjust if needed
    },

    title: {
        flex: 1,
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "16px",
        marginLeft: "-100px"   // 👈 adjust this value
    },
    infoRowFlex: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "5px"
    },

    voucherTitle: {
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        border: "1px solid #000",
        padding: "4px 12px",
        letterSpacing: "1px"
    },
    voucherBox: {
        textAlign: "center"
    },

    voucherType: {
        fontSize: "11px",
        marginTop: "2px"
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "8px",
        border: "1.5px solid #000"
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "40px",
        textAlign: "center"
    },
    signLine: {
        borderTop: "1px solid #000",
        width: "120px",
        margin: "0 auto 5px auto"
    },
    headerGrid: {
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        alignItems: "center",
        marginBottom: "10px"
    },

    logoBox: {
        justifySelf: "start"
    },

    logo: {
        height: "50px"
    },
   
    address: {
        fontSize: "11px",
        fontWeight: "normal",
        marginTop: "2px"
    },
    watermark: {
        position: "absolute",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        opacity: 0.05,
        zIndex: 0
    },

    watermarkImg: {
        width: "300px"
    },
    voucherBox: {
        border: "2px solid #000",
        padding: "12px",
        position: "relative",
        zIndex: 1
    },
};

export default VoucherPrint;